import { render, staticRenderFns } from "./Integrations.vue?vue&type=template&id=77166a36&"
import script from "./Integrations.vue?vue&type=script&lang=js&"
export * from "./Integrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1534120217/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77166a36')) {
      api.createRecord('77166a36', component.options)
    } else {
      api.reload('77166a36', component.options)
    }
    module.hot.accept("./Integrations.vue?vue&type=template&id=77166a36&", function () {
      api.rerender('77166a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Integrations.vue"
export default component.exports